export const DAY = 86400000
export const WEEK = DAY * 7
export const MONTH = DAY * 30

export const URL_DATE_FORMAT = "YY/MM/DD"
